export const labRequestSampleStep = {
    sampleControl: 'Control de muestras',
    analysisRequest: 'Solicitud de análisis',
}